<div *ngIf="!config">Loading <mat-spinner [diameter]="15"></mat-spinner></div>
<div *ngIf="config">
    <h1 class="is-flex justify-center">Edit {{ sortedStringSegments[sortedStringSegments.length - 1].segment_col_header }}</h1>
    <div *ngIf="!segments.length">Loading Segment Info <mat-spinner [diameter]="15"></mat-spinner></div>
    <div
        *ngIf="segments.length"
        class="is-flex"
    >
        <div>
            <div *ngFor="let segment of segments">
                <h5>{{ segment.segmentHeader }}</h5>
                <div class="is-flex">
                    <app-filter-input [property]="segment.originalSegmentFilter" />
                    <app-filter-input
                        *ngFor="let segmentFilter of segment.newSegmentFilters"
                        [property]="segmentFilter"
                    />
                </div>
            </div>
            <div *ngIf="hasSubtitle() && subtitleFilter">
                <h5>Subtitle ({{ data.periodStartDate | date: 'mediumDate' }})</h5>
                <div class="is-flex">
                    <app-filter-input [property]="originalSubtitleFilter" />
                    <app-filter-input [property]="subtitleFilter" />
                </div>
            </div>
            <div>
                <h5>Daypart</h5>
                <div class="is-flex">
                    <app-filter-input [property]="originalDaypartFilter" />
                    <app-filter-input [property]="daypartFilter" />
                </div>
            </div>
            <div>
                <h5>Aired Weeks</h5>
                <div class="is-flex">
                    <app-filter-input [property]="airedWeeksFilter" />
                </div>
            </div>
            <div *ngIf="data.isPolitical">
                <app-filter-input [property]="editOnDynamicRateCard" />
            </div>
        </div>
        <div class="level is-full-width button-row button-container">
            <div class="level-left"></div>
            <div class="level-right">
                <button
                    mat-stroked-button
                    class="button level-item is-danger popup-button"
                    (click)="close()"
                >
                    Cancel
                </button>
                <app-button
                    [class]="'level-item popup-button'"
                    [buttonText]="'Save'"
                    (buttonClick)="save()"
                    [type]="'flat'"
                />
            </div>
        </div>
    </div>
</div>
